module.exports = __webpack_public_path__ + "media/images/icons/chevron-right-35395ae7f4240ea29e56cf429246523c.svg";